import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface WorkspaceState {
  selectedClientId: string | null;
  selectedEntityId: string | null;
}

interface WorkspaceActions {
  setClient: (clientId: string) => void;
  setEntity: (entityId: string) => void;
  reset: () => void;
}

export interface WorkspaceStore extends WorkspaceState, WorkspaceActions {}

const initialState: WorkspaceState = {
  selectedClientId: null,
  selectedEntityId: null,
};

export const useWorkspaceStore = create<WorkspaceStore>()(
  persist(
    (set) => ({
      ...initialState,

      setClient: (clientId) =>
        set({ selectedClientId: clientId, selectedEntityId: null }),

      setEntity: (entityId) => set({ selectedEntityId: entityId }),

      reset: () => set(initialState),
    }),
    {
      name: 'workspace-store',
      partialize: (s) => ({
        selectedClientId: s.selectedClientId,
        selectedEntityId: s.selectedEntityId,
      }),
    }
  )
);
